export const isPasswordRecoveryLocation = (location) => Boolean(location && (
  /^\/account\/recovery\/?$/.test(location.pathname)
  || new URLSearchParams(String(location.hash || "").replace(/^#/, "")).get("type") === "recovery"
));

export const capturePasswordRecoveryLink = (location, history) => {
  const captured = { search: location.search || "", hash: location.hash || "" };
  // Scrub immediately; the recovery-only chunk validates the captured link.
  history?.replaceState(history.state, "", "/account/recovery");
  return captured;
};
